import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/carriers");

export const Route = createFileRoute("/carriers")({
  head: () => ({
    meta: [
      { title: "Carriers — LevelLoad" },
      { name: "description", content: "Carriers — LevelLoad transport planning." },
      { property: "og:title", content: "Carriers — LevelLoad" },
      { property: "og:description", content: "Carriers — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
